/**
 * Import dependencies.
 */
import $ from 'jquery';
import enquire from 'enquire.js';

enquire.register('screen and (max-width: 1113px)', {
	match() {
		const column = $('.hp-rollover-columns a,.hp-rollover-columns__column');
		column.on('click', function (e) {
			const isMore = $(e.target).hasClass('more');
			const link = $(this).attr('href');
			const target = $(this).attr('target');
			e.preventDefault();

			if (!isMore) {
				$(this).toggleClass('active');
			} else if (link) {
				$(`<a href="${link}" target="${target}"></a>`)[0].click();
			}
		});
	},
	unmatch() {
		const column = $('.hp-rollover-columns a,.hp-rollover-columns__column');
		column.removeClass('active');
		column.off('click');
	},
});
